import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { CURRENCIES, VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import Spinner from '../../components/Spinner'
import { OUTSOURCER_PATH, getOutsourcerById, updateOutsourcer } from '../../api/outsourcerApi'
import { updateOutsourcerAction } from '../../redux/feature/outsourcerSlice'
import CurrencyPicker from '../../components/currency/CurrencyPicker'

const OutsourcerEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [entity, setEntity] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${OUTSOURCER_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${OUTSOURCER_PATH}`, false)

    useEffect(() => {
        getOutsourcerById(id).then(res => setEntity(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateOutsourcer(id, entity).then(res => {
            dispatch(updateOutsourcerAction(res.data))
            closeTab()
            toast.success('Fasoncu güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Fasoncu Düzenle</label>
                <Input
                    label='Fasoncu Kodu'
                    name='code'
                    placeholder='Fasoncu kodu girin'
                    error={errors.code}
                    value={entity.code}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Fasoncu Adı'
                    name='name'
                    placeholder='Fasoncu adı girin'
                    error={errors.name}
                    value={entity.name}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Telefon Numarası'
                    name='phone'
                    placeholder='Telefon numarası girin'
                    error={errors.phone}
                    value={entity.phone}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Textarea
                    label='Adres'
                    name='address'
                    placeholder='Adres girin'
                    value={entity.address}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <CurrencyPicker
                    label="Kur"
                    value={entity.currency}
                    onChange={(currency) => setEntity(prevState => ({ ...prevState, currency }))}
                    text={(entity.currency) || 'Kur seçin'}
                    items={CURRENCIES}
                    error={errors.currency}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    value={entity.description}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default OutsourcerEditPage